import FreePlan       from './pricing/FreePlan'
import ProPlan        from './pricing/ProPlan'
import EnterprisePlan from './pricing/EnterprisePlan'

export default class Pricing extends React.PureComponent

  DEFAULT_BILLING_PERIOD = 'yearly'

  constructor: (props) ->
    super(props)

    @state =
      billingPeriod:       @props.currentUser?.planPeriod || DEFAULT_BILLING_PERIOD
      ctaTextKey:          'default'
      ctaIsFlashed:        false
      priceIsFlashed:      false
      moreFeaturesVisible: false

    @ref = React.createRef()

    @onClickProButton   = @onClickProButton.bind(this)
    @toggleMoreFeatures = @toggleMoreFeatures.bind(this)

  componentDidMount: ->
    window.Pricing = @ # to be able to call `window.Pricing.scrollAndFlashCta()` from outside

  scrollAndFlashCta: (key) ->
    @setState(
      ctaTextKey:   key
      ctaIsFlashed: true
    , =>
      @ref.current.scrollIntoView()
      setTimeout( =>
        @setState(ctaIsFlashed: false)
      , 6000)
    )

  onClickProButton: (e) ->
    e.preventDefault()

    if @props.currentUser
      @openCheckoutModal()
    else
      @redirectToSignUp()

  openCheckoutModal: ->
    modal = $("#modal-checkout")

    # Always (re-)load the content of the checkout modal (this content will be removed when the modal is closed -> see checkout.coffee)
    http.get(modal.data('url'), {}, (content) =>
      modal.find('.modal-content').html(content)
      modal.trigger('shown.neurooo.modal') # Will triggers rebinding of credit_card_fields(.coffee.erb) and checkout_form(.coffee.erb)
    )

    Bootstrap.Modal.getOrCreateInstance(modal[0]).show()

  redirectToSignUp: ->
    window.location.href = "#{@props.paths.signUpPath}?target_action=pro_plan&plan_period=#{@state.billingPeriod}"

  toggleMoreFeatures: =>
    @setState(moreFeaturesVisible: !@state.moreFeaturesVisible)

  updateBillingPeriod: (period) =>
    if @state.billingPeriod != period
      if @props.currentUser
        http.put("/#{@props.currentLocale}/account/subscriptions/update_renewal.json", { user: { planPeriod: period } })

      @setState(billingPeriod: period, @startPriceFlashAnimation)

  startPriceFlashAnimation: ->
    clearTimeout(@timeout) if @timeout

    @setState(priceIsFlashed: false, =>
      requestAnimationFrame( =>
        @setState(priceIsFlashed: true, =>
          @timeout = setTimeout( =>
            @setState(priceIsFlashed: false)
          , 500)
        )
      )
    )

  render: ->
    <div id="pricing"
         className="pricing container-fluid"
         ref={@ref}>
      <div className="container">
        { @renderCallToAction() }
        <h2 className="section-title">
          {@props.i18n.sectionTitle}
        </h2>
        <div className="row">
          <div className="col-12">
            { @renderBillingToggler() }
          </div>
          <div className="col-12 col-md-6 col-lg-4 col-free-plan">
            <FreePlan paths={@props.paths}
                      currentUser={@props.currentUser}
                      moreFeaturesVisible={@state.moreFeaturesVisible}
                      toggleMoreFeatures={@toggleMoreFeatures}
                      i18n={ { ...@props.i18n.freePlan, moreFeatures: @props.i18n.moreFeatures } } />
          </div>
          <div className="col-12 col-md-6 col-lg-4 col-pro-plan">
            <ProPlan price={@props.uiPrices[@state.billingPeriod]}
                     paths={@props.paths}
                     currentUser={@props.currentUser}
                     currentLocale={@props.currentLocale}
                     moreFeaturesVisible={@state.moreFeaturesVisible}
                     billingPeriod={@state.billingPeriod}
                     priceIsFlashed={@state.priceIsFlashed}
                     onClickProButton={@onClickProButton}
                     toggleMoreFeatures={@toggleMoreFeatures}
                     i18n={ { ...@props.i18n.proPlan, moreFeatures: @props.i18n.moreFeatures } } />
          </div>
          <div className="col-12 col-lg-4 col-enterprise-plan">
            <EnterprisePlan currentUser={@props.currentUser}
                            moreFeaturesVisible={@state.moreFeaturesVisible}
                            toggleMoreFeatures={@toggleMoreFeatures}
                            i18n={ { ...@props.i18n.enterprisePlan, moreFeatures: @props.i18n.moreFeatures } } />
          </div>
        </div>
      </div>
    </div>

  renderCallToAction: ->
    classes = "call-to-action"
    classes += " flashed" if @state.ctaIsFlashed

    ctaText = @props.i18n.ctaText[@state.ctaTextKey] || @props.i18n.ctaText['default']

    <div className={classes}>
      <a href="#" onClick={@onClickProButton}>
        { @props.i18n.ctaLink }
      </a>
      <span className="separator">•</span>
      <p dangerouslySetInnerHTML={{ __html: ctaText }} />
    </div>

  renderBillingToggler: ->
    monthlyButtonClasses = "btn btn-outline-primary"
    monthlyButtonClasses += " active" if @state.billingPeriod == 'monthly'

    yearlyButtonClasses = "btn btn-outline-primary"
    yearlyButtonClasses += " active" if @state.billingPeriod == 'yearly'

    <div className="billing-toggler">
      <div className="btn-group"
           role="group"
           data-locale={@props.currentLocale}
           aria-label={@props.i18n.billingToggler.label}>
        <button type="button"
                className={monthlyButtonClasses}
                onClick={@updateBillingPeriod.bind(this, 'monthly')}>
          {@props.i18n.billingToggler.monthly}
        </button>
        <button type="button"
                className={yearlyButtonClasses}
                onClick={@updateBillingPeriod.bind(this, 'yearly')}>
          {@props.i18n.billingToggler.yearly}
        </button>
      </div>
    </div>
